var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("loading-bg " + (_vm.loading ? '' : 'hide') + " " + (_vm.remove ? 'none' : ''))},[_c('ClipLoader',{staticClass:"loading-icon",attrs:{"loading":"loading","size":150,"sizeUnit":"px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }